module.exports = __webpack_public_path__ + "img/t1_2x.72fc804d.jpg";